import { getStoreByKey, setStoreByKey } from '../api/User';
import { ConsentFlows } from '../context/ConsentContext';
import { getUnixTimestamp } from './getUnixTimestamp';

export const flowSteps = {
  ENTER_FIRST_NAME: 'ENTER_FIRST_NAME',
  ENTER_LAST_NAME: 'ENTER_LAST_NAME',
  ENTER_EMAIL: 'ENTER_EMAIL',
  CREATE_PASSWORD: 'CREATE_PASSWORD',
  ENTER_VERIFICATION_CODE: 'ENTER_VERIFICATION_CODE',
  WHAT_IS_YOUR_ADDRESS_1: 'WHAT_IS_YOUR_ADDRESS_1',
  WHAT_IS_YOUR_ADDRESS_2: 'WHAT_IS_YOUR_ADDRESS_2',
  WHAT_IS_YOUR_ADDRESS_3: 'WHAT_IS_YOUR_ADDRESS_3',
  THIRTEEN_MONTHS_1: 'THIRTEEN_MONTHS_1',
  THIRTEEN_MONTHS_2: 'THIRTEEN_MONTHS_2',
  MPAN_WITH_ADDRESS_AND_MPAN_PREFILLED_V2:
    'MPAN_WITH_ADDRESS_AND_MPAN_PREFILLED_V2',
  MANUAL_MPAN_ENTRY: 'MANUAL_MPAN_ENTRY',
  TERMS_AND_CONDITIONS: 'TERMS_AND_CONDITIONS',
  TERMS_AND_CONDITIONS_MODAL: 'TERMS_AND_CONDITIONS_MODAL',
  MPAN_WHATS_THIS_MODAL: 'MPAN_WHATS_THIS_MODAL',
  PAYMENT_CARD_OR_IHD_CANT_FIND_IHD: 'PAYMENT_CARD_OR_IHD_CANT_FIND_IHD',
  PAYMENT_CARD_OR_IHD: 'PAYMENT_CARD_OR_IHD',
  YOUR_SMART_METER_GUID_MAC_EUI: 'YOUR_SMART_METER_GUID_MAC_EUI',
  RIGHT_TO_ACCESS_PAYMENT_CARD: 'RIGHT_TO_ACCESS_PAYMENT_CARD',
  DEFAULT_IHD_W_LINK_BACK_TO_PAYMENT_CARD:
    'DEFAULT_IHD_W_LINK_BACK_TO_PAYMENT_CARD',
  CC_SET_UP_ERROR: 'CC_SET_UP_ERROR',
  CC_SET_UP_OK: 'CC_SET_UP_OK',
  CANNOT_CONFIRM_CC: 'CANNOT_CONFIRM_CC',
  CANNOT_CONFIRM_IHD: 'CANNOT_CONFIRM_IHD',
  OVERVIEW_SOLAR_PANEL_CTA: 'OVERVIEW_SOLAR_PANEL_CTA',
  SMART_METER_NOT_COMPATIBLE_V2: 'SMART_METER_NOT_COMPATIBLE_V2',
  SMART_METER_NOT_COMPATIBLE_SOLAR_CTA: 'SMART_METER_NOT_COMPATIBLE_SOLAR_CTA',
  SUNSAVE_SOLAR_FORM: 'SUNSAVE_SOLAR_FORM',
  CONNECTING_TO_SMART_METER: 'CONNECTING_TO_SMART_METER',
  CONFIRMATION: 'CONFIRMATION',
  ACCOUNT_DELETION_CONFIRMATION: 'ACCOUNT_DELETION_CONFIRMATION',
  RECONFIRM_NOW_LANDING: 'RECONFIRM_NOW_LANDING',
  RECONFIRM_SOON_LANDING: 'RECONFIRM_SOON_LANDING',
  RECONFIRM_CONFIRMATION: 'RECONFIRM_CONFIRMATION',
};

const initialOnboardingShape = {
  [flowSteps.ENTER_FIRST_NAME]: '',
  [flowSteps.ENTER_LAST_NAME]: '',
  [flowSteps.ENTER_EMAIL]: '',
  [flowSteps.CREATE_PASSWORD]: '',
  [flowSteps.ENTER_VERIFICATION_CODE]: '',
  [flowSteps.WHAT_IS_YOUR_ADDRESS_1]: '',
  [flowSteps.WHAT_IS_YOUR_ADDRESS_2]: '',
  [flowSteps.WHAT_IS_YOUR_ADDRESS_3]: '',
  [flowSteps.THIRTEEN_MONTHS_1]: '',
  [flowSteps.THIRTEEN_MONTHS_2]: '',
  [flowSteps.MPAN_WITH_ADDRESS_AND_MPAN_PREFILLED_V2]: '',
  [flowSteps.MANUAL_MPAN_ENTRY]: '',
  [flowSteps.TERMS_AND_CONDITIONS]: '',
  [flowSteps.TERMS_AND_CONDITIONS_MODAL]: '',
  [flowSteps.PAYMENT_CARD_OR_IHD_CANT_FIND_IHD]: '',
  [flowSteps.PAYMENT_CARD_OR_IHD]: '',
  [flowSteps.YOUR_SMART_METER_GUID_MAC_EUI]: '',
  [flowSteps.RIGHT_TO_ACCESS_PAYMENT_CARD]: '',
  [flowSteps.DEFAULT_IHD_W_LINK_BACK_TO_PAYMENT_CARD]: '',
  [flowSteps.CONNECTING_TO_SMART_METER]: '',
  [flowSteps.CANNOT_CONFIRM_CC]: '',
  [flowSteps.CANNOT_CONFIRM_IHD]: '',
  [flowSteps.CC_SET_UP_ERROR]: '',
  [flowSteps.CC_SET_UP_OK]: '',
  [flowSteps.OVERVIEW_SOLAR_PANEL_CTA]: '',
  [flowSteps.SMART_METER_NOT_COMPATIBLE_V2]: '',
  [flowSteps.SMART_METER_NOT_COMPATIBLE_SOLAR_CTA]: '',
  [flowSteps.SUNSAVE_SOLAR_FORM]: '',
  [flowSteps.CONFIRMATION]: '',
};

export const recordFlowProgress = async (
  step,
  uploadProgress = true,
  flowType = ConsentFlows.ONBOARDING,
) => {
  if (!Object.values(flowSteps).includes(step)) {
    return;
  }

  let currentItems;

  try {
    const localStorageValues = localStorage.getItem(`${flowType}_progress`);
    if (localStorageValues) {
      currentItems = JSON.parse(localStorageValues);
    } else if (uploadProgress) {
      currentItems = await getStoreByKey('onboarding_progress');
    } else {
      throw new Error('Could not retrieve currentItems');
    }
  } catch (error) {
    console.log('error', error);
    currentItems = initialOnboardingShape;
  }

  currentItems[step] = getUnixTimestamp();

  try {
    if (uploadProgress) {
      await setStoreByKey(`${flowType}_progress`, currentItems);
    }
    localStorage.setItem(`${flowType}_progress`, JSON.stringify(currentItems));
  } catch (error) {
    console.log('error', error);
  }
};
